'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Global as Global$1, css } from '@emotion/react';
import { isFunction } from '@s7/utils';
import { useTheme } from '../theming/propagation/ThemeProvider.js';

const Global = ({ styles })=>{
    const theme = useTheme();
    return /*#__PURE__*/ jsx(Global$1, {
        styles: css(isFunction(styles) ? styles(theme) : styles)
    });
};

export { Global };
//# sourceMappingURL=Global.js.map
